export default __webpack_public_path__ + "static/media/banner.36a2bba5.png";